import { OrganizationEventsForBookingData } from "../../models/organizationEventsForBookingData";
import { BaseCrudService } from "../baseCrudService";
import apiRoutes from "../apiRoutes";

/**
 * The organization events for booking service
 */
export class OrganizationEventsForBookingService extends BaseCrudService {
  /**
   * Fetches the events bookable by the given organization for its members.
   * The backend filters events by participation-type visibility for the
   * organization. See the spec for the visibility rule.
   *
   * @param organizationId The organization the orga admin is booking for.
   */
  async getEventForBookingsByOrganization(
    organizationId: string
  ): Promise<OrganizationEventsForBookingData[]> {
    const response = await this.getAll<OrganizationEventsForBookingData[]>(
      apiRoutes.events_organization_booking,
      { organization_id: organizationId }
    );
    return response.data;
  }
}
